import { useEffect } from 'react'

import { useRouter } from 'next/router'

function usePreserveScroll() {
  const router = useRouter()
  const currentPath = router.asPath // `asPath` gives the full path, including query parameters

  useEffect(() => {
    const handleRouteChangeStart = (url) => {
      const basePath = currentPath.split('?')[0] // Remove query parameters for base path comparison
      const newBasePath = url.split('?')[0] // Remove query parameters from new URL

      if (newBasePath.startsWith(basePath) && newBasePath !== basePath) {
        // Save the current scroll position if it's a child route
        sessionStorage.setItem(currentPath, window.scrollY.toString())
      } else {
        // Clear the stored scroll position for the current path if navigating to an unrelated path
        sessionStorage.removeItem(currentPath)
      }
    }

    // Listen for route changes before they happen
    router.events.on('routeChangeStart', handleRouteChangeStart)

    return () => {
      // Remove event listener when the component unmounts
      router.events.off('routeChangeStart', handleRouteChangeStart)
    }
  }, [currentPath, router.events])

  useEffect(() => {
    // Restore the scroll position when the component mounts or the path changes
    const savedPosition = sessionStorage.getItem(currentPath)
    if (savedPosition) {
      window.scrollTo(0, parseInt(savedPosition, 10))
    }
  }, [currentPath])
}

export default usePreserveScroll
